"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function InitialiseArray(arraySize) {
    var rv = new Array(arraySize);
    while (--arraySize >= 0) {
        rv[arraySize] = 0;
    }
    return rv;
}
exports.InitialiseArray = InitialiseArray;
//# sourceMappingURL=ArrayUtils.js.map